import {createContext} from "react"



const LoadingContext = createContext(true)

export default LoadingContext ;
